import requestLogin from './requestLogin';

const api = { requestLogin };

export default api;
